import { Component, Input, OnInit } from '@angular/core';
import { MenuModel } from '@app/shared/interfaces/menu-model';
import { LoginService } from '@app/shared/services/Login.service';
import { LayoutService } from '@app/shared/services/layout.service';

@Component({
  selector: 'app-navigation-sider',
  templateUrl: './navigation-sider.component.html',
  styleUrls: ['./navigation-sider.component.less'],
})
export class NavigationSiderComponent implements OnInit {
  @Input() isCollapsed: boolean = false;
  menus: MenuModel[] = [];
  constructor(
    public layoutService: LayoutService,
    private authService: LoginService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      if (this.authService.loginStatus.getValue()) {
        this.layoutService.getMenu('main', (d) => {
          this.menus = d;
        });
      }
    }, 300);
  }
}
